import src0 from '../../assets/images/snake/body.png';
import src1 from '../../assets/images/snake/body-down-to-left-1.png';
import src2 from '../../assets/images/snake/body-down-to-right-1.png';
import src3 from '../../assets/images/snake/body-left-to-down-1.png';
import src4 from '../../assets/images/snake/body-up-to-left-1.png';
import src5 from '../../assets/images/snake/body-up-to-right-1.png';
import src6 from '../../assets/images/snake/head-0.png';
import src7 from '../../assets/images/snake/head-1.png';
import src8 from '../../assets/images/snake/head-down-to-left-1.png';
import src9 from '../../assets/images/snake/head-down-to-right-1.png';
import src10 from '../../assets/images/snake/head-left-to-down-1.png';
import src11 from '../../assets/images/snake/head-up-to-left-1.png';
import src12 from '../../assets/images/snake/head-up-to-right-1.png';
// import src13 from '../../assets/images/snake/snake.png';
import src14 from '../../assets/images/snake/tail-0.png';
import resultSrcBg from '../../assets/images/share/sharebackground.png';
import resultSrcCoins from '../../assets/images/share/coinsresultx2.png';

export const assetsImages = [
    { id: 'sharebackground', src: resultSrcBg },
    { id: 'coinsresultx2', src: resultSrcCoins },
];

export const snakeImages = [
    src0,
    src1,
    src2,
    src3,
    src4,
    src5,
    src6,
    src7,
    src8,
    src9,
    src10,
    src11,
    src12,
    src14
];
